module.exports = __webpack_public_path__ + "static/media/tab1.260204b1.png";